// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"8802be71","772":"b7783fa1","921":"a95c8092"}[chunkId] + ".chunk.js";
};